<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Produtos</h1>
        <p class="text-sm text-gray-500">Gerencie seu catálogo de produtos</p>
      </div>
      <button (click)="createProduct()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Novo Produto
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
      <input type="text" (input)="onSearchChange()" [(ngModel)]="searchTerm" placeholder="Buscar por nome ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      <p-dropdown
          [options]="status"
          [(ngModel)]="selectedStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      
      <div class="flex items-center">
          <p-checkbox inputId="minimumStock" (onChange)="onStatusChange()" [(ngModel)]="minimumStock" [binary]="true" />
          <label for="minimumStock" class="ml-2"> Estoque Mínimo </label>
      </div>
      <div class="flex items-center">
        <p-checkbox inputId="negativeStock" [(ngModel)]="negativeStock" (onChange)="onStatusChange()" [binary]="true" />
        <label for="negativeStock" class="ml-2"> Estoque Negativo </label>
      </div>
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} produto(s) encontrado(s)
      </div>

      <div class="flex justify-end">
        <p-button (onClick)="export()" label="Exportar"></p-button>
      </div>
    </div>
  </div>

  <div class="px-6 py-2">
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="products" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código | Código de Barras</th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Grupo</th>
            <th class="text-left px-6 py-3">Família</th>
            <th class="text-left px-6 py-3">Setor</th>
            <th class="text-left px-6 py-3">Subgrupo</th>
            <th class="text-left px-6 py-3">Preço (R$)</th>
            <th class="text-left px-6 py-3">Estoque</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ product.code }} | {{ product.barCode }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ product.description }}</td>
            <td class="px-6 py-2 text-gray-700">{{ getGroupLabel(product) }}</td>
            <td class="px-6 py-2 text-gray-700">{{ getFamilyLabel(product) }}</td>
            <td class="px-6 py-2 text-gray-700">{{ getSectorLabel(product) }}</td>
            <td class="px-6 py-2 text-gray-700">{{ getSubgroupLabel(product) }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ product.priceSelling | number: '1.2-2' }}</td>
            <td class="px-6 py-2">
              <span class="px-2 py-1 rounded-full text-xs" [ngClass]="{
                'bg-green-100 text-green-800': product.currentStock >= product.minimumStock,
                'bg-yellow-100 text-yellow-800': product.currentStock < product.minimumStock && product.currentStock > 0,
                'bg-red-100 text-red-800': product.currentStock < 0
              }">{{ product.currentStock }}</span>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Editar produto"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(product)">
                </p-button>
                <p-button
                  pTooltip="Duplicar produto"
                  icon="pi pi-copy"
                  text
                  severity="secondary"
                  (click)="duplicate(product)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center py-8 text-gray-500">
              Nenhum produto encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>

</div>